import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';
import brandStyles from '../styles/BrandMark.module.css';
import styles from '../styles/PublicLegalPage.module.css';

const PublicLegalFooter = () => (
  <footer className={styles.footer}>
    <BrandMark size={22} className={brandStyles.footerMark} />
    <div className={styles.footerLinks}>
      <Link to="/sms-opt-in" className={styles.link}>SMS Opt-In</Link>
      <Link to="/privacy" className={styles.link}>Privacy Policy</Link>
      <Link to="/terms" className={styles.link}>Terms of Service</Link>
      <Link to="/login" className={styles.link}>Sign In</Link>
    </div>
    <p>&copy; {new Date().getFullYear()} LOTW League. All rights reserved.</p>
  </footer>
);

export default PublicLegalFooter;
